<template>
    <role-required role="Member">
        <template #no-role>
            <b-card class="text-center">
                <h3>Please complete a membership form to continue.</h3>
                <div class="text-center">
                    <router-link
                        :to="{ name: 'membership' }"
                        class="sc-btn"
                    >
                        Next <font-awesome-icon icon="chevron-right" class="ml-2" />
                    </router-link>
                </div>
            </b-card>
        </template>
        <template #not-authorized>
            <b-card
                title="Not authorized"
                sub-title="You have not been granted access to this group's resources."
            ></b-card>
            <request-user-access />
        </template>
       <home-links/>
        <div class="row mt-2">
            <notification-list />
        </div>
    </role-required>
</template>
<script>
// @ is an alias to /src
import { mapState } from 'vuex';
import RoleRequired from '@/components/authz/RoleRequired.vue';
import PopupVue from '@/components/dialog/Popup.vue';
import Form         from '../student/Form.vue';
import ClassesList  from '../teacher/ClassesList.vue';
import RequestUserAccess from '../user/requests/RequestUserAccess.vue';
import NotificationList from '../notifications/NotificationList.vue';
import HomeLinks from './HomeLinks.vue';

export default {
    components: {
        "app-form": Form,
        "teacher-classes-list": ClassesList,
        "popup": PopupVue,
        "role-required": RoleRequired,
        "request-user-access": RequestUserAccess,
        "notification-list": NotificationList,
        HomeLinks
    },
    computed: mapState( [
        "user",
        "semester",
        "settings",
        "permissions"
    ])
}
</script>